import SearchParamsBase from '../../../Elements/SearchParamsBase';

export default class EvaluatorPaymentsExportSearchParams extends SearchParamsBase {
  static saveType = 'EvaluatorPaymentsExportSearchParams';
  initialize() {
    this.Report = null;
    this.SelectedThirdPartyEvaluatorIds = null;
    this.ThirdPartyEvaluatorIdsText = null;
    this.SelectedEvaluatorIds = null;
    this.EvaluatorIdsText = null;
  }
}
